import type { WorkstationRunner } from '../workstation-fixture'

export function isDrawRunner(runner: WorkstationRunner): boolean {
  const name = runner.name.trim().toLowerCase()
  const id = runner.id.trim().toLowerCase()
  return id === 'draw' || id === 'x' || name === 'the draw' || name === 'draw' || name === 'x'
}

/** Match odds runners for display — keep every book runner, including The Draw. */
export function visibleMatchRunners(runners: WorkstationRunner[]): WorkstationRunner[] {
  return runners
}
